module.exports = __webpack_public_path__ + "img/ManInMainBlock1.90d8cb52.png";